/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'navigation/marker-white': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><path pid="0" _fill="#e25046" d="M0 0h34v34H0z"/><path pid="1" d="M24.88 7A11.15 11.15 0 009.12 22.78L16.3 30a1 1 0 001.4 0l7.18-7.18a11.14 11.14 0 000-15.82zM8.16 6a12.5 12.5 0 0117.68 17.74l-7.18 7.18a2.36 2.36 0 01-3.32 0l-7.18-7.18a12.51 12.51 0 010-17.68z" fill-rule="evenodd" _fill="#fff"/><path pid="2" d="M24.09 14.9A7.1 7.1 0 1117 7.8a7.08 7.08 0 017.09 7.1z" _fill="#fff"/></g></g>'
  }
})
